<template>
  <div class="content">
    <!-- 上白板step -->
    <div class="nav-border">
      <span class="nav-lspan">【{{this.resData.recNo}}】<span style="color: #1890ff;">{{this.resData.goodName}}</span> 服务项目交付</span>
    </div>

    <!-- body -->
    <div class="body">
      <div class="body-content public_scrill">
        <!-- 表头 -->
        <div class="content_one">
          <div class="form_title">客户预约信息</div>
        </div>

        <!-- 表单1 -->
        <FormInput
          style="margin-top: 10px;"
          class="form_component"
          :id="'formOne'"
          ref="ruleForms"
          :label_width="'200px'"
          :Formlist="formlist"
          @handleClickBtn = "labelModal"
          @tagClose = "tagClose"
        />

        <!-- 表头 -->
        <div class="content_one">
          <div class="form_title">项目服务交付记录</div>
          <a-button v-if="formVisible" class="bottom-button" style="margin-right: 10px;" type="primary" @click="handleComplete(true)" :loading="completeLoading">完成交付</a-button>
        </div>

        <!-- 表格 -->
        <!-- 详情 -->
        <div v-if="!formVisible">
          <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_grid.field"
          :data-source="relevanceBatch_grid.row"
          :rowKey="(record, index) => { return record.id;}"
          size="small"
          :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
          :pagination="false"
          :loading="tableLoading"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index">
            {{index + 1}}
          </span>
          <!-- 项目类别 -->
          <span slot="goodsType" slot-scope="text, record">
            {{ record.goodsType | DictionaryFilter("GOODS_TYPE") }}
          </span>
          <!-- 服务状态 -->
          <span slot="recStatus" slot-scope="text, record">
            <span v-if="record.recStatus == '1' || record.recStatus == '5'"><a-badge color="gold" /></span>
            <span v-else-if="record.recStatus == '4'"><a-badge color="red"/></span>
            <span v-else-if="record.recStatus == '2' || record.recStatus == '3'"><a-badge color="cyan"/></span>
            {{ record.recStatus | DictionaryFilter("REC_STATUS") }}
          </span>
           <!-- 更多操作 -->
          <span slot="operation" slot-scope="data" class="ellipsis">
            <!-- 未开始 -->
            <div v-if="data.recStatus == '4' && formVisible == true" >
              <a @click="handle_order(data)">派单</a>
              <a @click="handle_detail(data)">详情</a>
            </div>
            <!-- 服务中 -->
            <div v-if="data.recStatus == '1' && formVisible == true">
              <a style="margin-left: 20px;" type="primary" @click="handleAdd(data)" :loading="addLoading">添加事件</a>
              <a @click="handle_detail(data)">详情</a>
            </div>
            <!-- 已完成 -->
            <div v-if="data.recStatus == '2'">
              <a @click="handle_detail(data)">详情</a>
            </div>
            <!-- 待确认 -->
            <div v-if="data.recStatus == '5' && formVisible == true">
              <a @click="handle_confirm(data)">确认</a>
              <a @click="handle_detail(data)">详情</a>
            </div>
            <div v-if="data.recStatus == '3'">
              <a @click="handle_detail(data)">详情</a>
            </div>
          </span>
        </a-table>
        </div>
        <!-- 交付 -->
        <div v-if="formVisible">
          <a-table
          class="antd-table"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange , columnWidth: '50px'}"
          bordered
          :columns="relevanceBatch_grid.field"
          :data-source="relevanceBatch_grid.row"
          :rowKey="(record, index) => { return record.id;}"
          size="small"
          :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
          :pagination="false"
          :loading="tableLoading"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index">
            {{index + 1}}
          </span>
          <!-- 项目类别 -->
          <span slot="goodsType" slot-scope="text, record">
            {{ record.goodsType | DictionaryFilter("GOODS_TYPE") }}
          </span>
          <!-- 服务状态 -->
          <span slot="recStatus" slot-scope="text, record">
            <span v-if="record.recStatus == '1' || record.recStatus == '5'"><a-badge color="gold" /></span>
            <span v-else-if="record.recStatus == '4'"><a-badge color="red"/></span>
            <span v-else-if="record.recStatus == '2' || record.recStatus == '3'"><a-badge color="cyan"/></span>
            {{ record.recStatus | DictionaryFilter("REC_STATUS") }}
          </span>
           <!-- 更多操作 -->
          <span slot="operation" slot-scope="data" class="ellipsis">
            <!-- 未开始 -->
            <div v-if="data.recStatus == '4' && formVisible == true" >
              <a @click="handle_order(data)">派单</a>
              <a @click="handle_detail(data)">详情</a>
            </div>
            <!-- 服务中 -->
            <div v-if="data.recStatus == '1' && formVisible == true">
              <a class="bottom-button" style="margin-left: 20px;" type="primary" @click="handleAdd(data)" :loading="addLoading">添加事件</a>
              <a @click="handle_detail(data)">详情</a>
            </div>
            <!-- 已完成 -->
            <div v-if="data.recStatus == '2'">
              <a @click="handle_detail(data)">详情</a>
            </div>
            <!-- 待确认 -->
            <div v-if="data.recStatus == '5' && formVisible == true">
              <a @click="handle_confirm(data)">确认</a>
              <a @click="handle_detail(data)">详情</a>
            </div>
            <div v-if="data.recStatus == '3'">
              <a @click="handle_detail(data)">详情</a>
            </div>
          </span>
        </a-table>
        </div>
      </div>
    </div>

    <!-- 下白板按钮 -->
    <div class="blank-border">
      <a-button class="bottom-button" type="primary" ghost @click="cancle" >返回</a-button>
    </div>

    <!-- 派单 -->
    <orderModal
      v-if="orderVisible"
      :modalTitle="orderModalTitle"
      :data="serviceData"
      @close="orderClose" 
      @handleOk="orderlHandleOk"
    ></orderModal>

     <!-- 添加事件 -->
     <addModal
      v-if="addVisible"
      :modalTitle="addModalTitle"
      :data="serviceData"
      :progressId="progressId"
      @close="close" 
      @handleOk="addlHandleOk"
    ></addModal>

     <!-- 详情 -->
     <detailModal
      v-if="detailVisible"
      :modalTitle="detailModalTitle"
      :data="serviceData"
      @close="detailClose" 
      @handleOk="detaillHandleOk"
    ></detailModal>

    <!-- 添加事件 -->
    <labelModal
      v-if="lableVisible"
      :recId = "recId"
      :labelListQuery = "labelList"
      @close="close" 
      @handleOk="lableHandleOk"
    ></labelModal>
  </div>
</template>
    
<script>
import { getId,queryDeliverCustgoods,saveDelivers,deleteRecLabel} from "@/api/api.js";
import orderModal from "./modal-hunt/dispatch-orders-modal.vue";
import addModal from "./modal-hunt/add-modal.vue";
import detailModal from "./modal-hunt/detail-modal.vue";
import labelModal from "./modal-hunt/lable-modal.vue";
import { DictionaryService } from "@common/services/dictionary.service";
export default {
  name: "",
  components: {
    orderModal,
    addModal,
    detailModal,
    labelModal
  },
  props: {
    Title: {
      type: String,
      default: () => "Title",
    },
  },
  data() {
    return {
      formVisible: false,
      recId : "",//服务ID
      formlist: [
        {
          row: 1,
          ishowNode: true,
          name: "custNo",
          lable: "预约客户编号",
          value: "1",
          type: "input",
        },
        {
          row: 1,
          ishowNode: true,
          name: "custName",
          lable: "预约客户姓名",
          value: "1",
          type: "input",
        },
        {
          row: 1,
          ishowNode: true,
          name: "prName",
          lable: "预约项目名称",
          value: "1",
          type: "input",
        },
        {
          row: 1,
          ishowNode: true,
          name: "count",
          lable: "预约项目数量",
          value: "1",
          type: "input",
        },
        {
          row: 1,
          ishowNode: true,
          name: "networkName",
          lable: "服务地点",
          value: "1",
          type: "input",
        },
        {
          row: 1,
          ishowNode: true,
          name: "anonymizeStatus",
          lable: "是否匿名",
          value: "1",
          type: "input",
        },
        {
          row: 1,
          ishowNode: true,
          name: "contacts",
          lable: "联系人",
          value: "1",
          type: "input",
        },
        {
          row: 1,
          ishowNode: true,
          name: "phone",
          lable: "联系电话",
          value: "1",
          type: "input",
        },
        {
          disabled: false,
          row: 2,
          ishowNode: true,
          name: "custRemark",
          lable: "服务订单客户备注",
          type: "textarea",
          value: "",
        },
        {
          disabled: false,
          row:2,
          ishowNode: true,
          name: "labelList",
          lable: "客户标签",
          btn_lable:"添加标签",
          type: "selectTagSlot",
          value: '',
        },

      ],
      selectedRowKeys: [],
      list: [],
      selectedRows:[],//多选数据
      //查询加载
      tableLoading:false,
      relevanceBatch_grid: {
        height: "calc(100vh - 250px)",
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            width: 60,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "项目类别",
            align: "center",
            width: 100,
            dataIndex: "goodsType",
            ellipsis: true,
            scopedSlots: {
              customRender: "goodsType",
            },
          },
          {
            title: "项目名称",
            align: "center",
            width: 160,
            dataIndex: "goodName",
            ellipsis: true,
          },
          {
            title: "交付数量",
            colSpan: 1,
            width: 100,
            dataIndex: "count",
            align: "center",
            ellipsis: true,
          },
          {
            title: "业务员",
            colSpan: 1,
            align: "center",
            width: 100,
            ellipsis: true,
            dataIndex: "busName",
          },
          {
            title: "联系方式",
            colSpan: 1,
            align: "center",
            width: 100,
            ellipsis: true,
            dataIndex: "phoneNo",
          },
          {
            title: "交付说明",
            colSpan: 1,
            align: "center",
            width: 200,
            ellipsis: true,
            dataIndex: "serviceRemark",
          },
          {
            title: "服务状态",
            colSpan: 1,
            align: "center",
            width: 80,
            ellipsis: true,
            dataIndex: "recStatus",
            scopedSlots: {
              customRender: "recStatus",
            },
          },
          {
            title: "操作",
            width: 140,
            align: "center",
            scopedSlots: {
              customRender: "operation",
            },
          },
        ]
      },
      formlistTwo: [
        {
          required:true, // 是否必输
          disabled: false,
          row: 2,
          ishowNode: true,
          name: "serviceRemark",
          lable: "客服交付说明",
          type: "textarea",
          value: "",
        },
      ],
      //添加弹窗
      addVisible: false,
      addModalTitle: "",
      //派单弹窗
      orderVisible: false,
      orderModalTitle: "",
      //详情弹窗
      detailVisible: false,
      detailModalTitle: "",
      serviceData:{},
      //响应内容
      resData: {},
      confirmLoading: false,
      completeLoading:false,
      addLoading:false,
      progressId:"",
      recNos:[],
      disUse:false,//禁用交付按钮
      isUse: false,
      //标签弹窗
      lableVisible: false,
      labelList:[],
      formInpuVisble:true,
    };
  },
  mounted() {
    DictionaryService.getAllNeedDic(["REC_STATUS","GOODS_TYPE","YES_NO"]).then((res) => {
      this.recId = this.$route.query.recId;
      if (this.$route.query.title == "去交付") {
        this.formVisible = true;
      } else if (this.$route.query.title == "详情") {
        this.formVisible = false;
      }
      //获取服务交付详情信息
      this.queryList();
      this.relevanceBatch_grid.width = 0;
      this.relevanceBatch_grid.field.map(item => {
      this.relevanceBatch_grid.width += item.width;
    });
    });
  },
  methods: {
    onSelectChange(data, selectedRows) {
      this.selectedRows = selectedRows;
      this.selectedRowKeys = data;
    },
    //查询
    queryList() {
      queryDeliverCustgoods({
        id : this.recId
      })
      .then(res => {
        if (res.code == "0000") {
          this.resData = res.content;

          // //表单1赋值
          this.labelList = [];
          this.formlist[0].value = this.resData.custNo;
          this.formlist[1].value = this.resData.custName;
          this.formlist[2].value = this.resData.prName;
          this.formlist[3].value = this.resData.count;
          this.formlist[4].value = this.resData.networkName;
          this.formlist[5].value = (this.resData.anonymizeStatus == null || this.resData.anonymizeStatus == '0') ? '否':'是';
          this.formlist[6].value = this.resData.contacts;
          this.formlist[7].value = this.resData.phone;
          this.formlist[8].value = this.resData.custRemark;
          this.formlist[9].value = this.resData.labelList;

          if (this.resData.labelList.length > 0) {
            this.labelList = this.resData.labelList;
          }

          //表格赋值
          this.relevanceBatch_grid.row = this.resData.serviceList;
           //是否禁用交付按钮
           this.resData.serviceList.forEach((value)=>{
              if(value.recStatus =='5'){
                this.disUse = false;
                return;
              }
          })
        }
      });
    },
    //派单
    handle_order(data){
      this.orderVisible = true;
      this.orderModalTitle = "服务派单";
      this.serviceData=data;
    },
     //弹窗关闭(派单)
     orderClose() {
      this.orderVisible = false;
    },
    //添加弹窗确认(派单)
    orderlHandleOk() {
      this.queryList();
      this.orderVisible = false;
    },
    // 取消按钮
    cancle() {
      if (this.$route.query.pages == '工作台') {
        this.$router.push({path:'/home/home-page/home-page',query:{key:'2'}})
      } else if (this.$route.query.pages == '工作台全部') {
        this.$router.push({path:'/home/home-page/home-page',query:{key:'1'}})
      }else {
        this.$router.go(-1); 
      }
    },
     //添加事件
     handleAdd(data){
      getId().then((res) => {
        this.progressId = res.content.id;
        this.addVisible = true;
        this.addModalTitle = "服务事件添加";
        this.serviceData=data;
      })
    },
     //弹窗关闭(添加事件)
     close() {
       this.addVisible = false;
       this.lableVisible = false;
    },
    //添加弹窗确认(添加事件)
    addlHandleOk() {
      this.queryList();
      this.addVisible = false;
    },
     //详情
     handle_detail(data){
      this.detailVisible = true;
      this.detailModalTitle = "服务进度详情";
      this.serviceData=data;
    },
     //弹窗关闭(详情)
     detailClose() {
      this.detailVisible = false;
    },
    //添加弹窗确认(详情)
    detaillHandleOk() {
      this.queryList();
      this.detailVisible = false;
    },
    //确认
    handle_confirm(data){
      this.recNos.push(data.recNo);
      this.handleComplete(false);
    },
    //完成交付
    handleComplete(batch) {
      this.isUse = false;
      if(batch){
        if(this.selectedRows.length == 0){
          return this.$message.warning("请选择交付数据！")
        }
        this.recNos=[];
        this.selectedRows.forEach((val) => {
          this.recNos.push(val.recNo);
        })
        //去重
        this.recNos = [...new Set(this.recNos)];
        this.selectedRows.forEach((value)=>{
            if(value.recStatus !='5'){
              this.isUse = true;
              return; 
            }
        })
      }
      if(this.isUse){
        this.$message.warning("只能选择服务状态为“待确认”的数据进行交付！") 
      }else{
        this.completeLoading = true;
        saveDelivers({
          recNos: this.recNos,
          recStatus: "2",
          serviceRemark: "完成交付-",
        }).then(
          (res) => {
            if (res.code == '0000') {
              this.completeLoading = false;
              this.$message.success('完成交付成功！');
              this.queryList();
              this.selectedRowKeys = [];
              this.selectedRows = [];
            }
          },
          (err) => {
            this.completeLoading = false;
          });
      }
    },
    //添加标签
    labelModal() {
      this.lableVisible = true;
      this.recId = this.$route.query.recId;
    },
    //确定标签
    lableHandleOk() {
      this.lableVisible = false;
      this.queryList();
    },
    //关闭标签
    tagClose(data) {
      deleteRecLabel({id: data.relId}).then(
        (res) => {
          this.queryList();
        },
        (err) => {
            this.$message.error(err.message || '查询失败')
            //this.Tableloading = false
        })
    }
  },
};
</script>
    
<style lang="less" scoped>
.content {
  height: 90%;

  .nav-border {
    border-bottom: 1px solid #e4e4e4;
    width: 100%;
    height: 50px;
    background: #fff;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    .nav-lspan {
      font-size: 16px;
      color: #999999;
      float: left;
      margin: 8px 8px 8px 8px;
    }
  }
  .body {
    display: flex;
    justify-content: space-between;
    height: 83%;
    background: #fff;
    .body-content {
      padding: 15px 20px 15px 20px;
      flex: 1;
      height: 100%;
      overflow-y: auto;

      .content_one{
        height: 50px;
        background-color: #F6F6FA;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .blank-border {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    .bottom-button {
      float: right;
      margin-left: 20px;
    }
  }
}

.addbutton {
  border: 1px #009de5 solid;
  color: #009de5;
  float: right;
  margin: 10px;
  z-index: 100;
}

/deep/ .ant-upload-list {
  display: none;
}

.uploadfilelist {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 16px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  zoom: 1;

  .fileico {
    margin: 10px;
  }
  .itemname {
  }
  .itemsta {
    float: right;
    margin-right: 30%;
  }
  .download {
    float: right;
    margin: 5px;
  }
  .del {
    float: right;
    margin: 5px;
  }
}
.uploadfilelist:hover {
  background: #f3fbff;
}

/deep/ .form_title{
  margin-bottom: 0px !important;
  display: flex;
  align-items: center;
  height: 14px;
  color: #333;
  padding-left: 5px;
  font-size: 14px;
  border-left: 4px solid #16828b;
  margin-left: 15px;
}
</style>